<div class="container bg2 page-sub footer-none">

  <section class="header fixed">

    <article class="header-page">

      <a class="close-btn" backButton></a>

      <div class="page-name-box">책임의 한계와 법적인 고지</div>

    </article>

  </section>

  <section class="setting-page">
    <div class="inner wrap">

      <div class="setting-list">

        <div class="setting-box">
          <div class="setting-des-box">
            ‘듣고 배우는 한국어’라는 명칭으로 앱과 웹으로 제공이 되는 본 온라인 서비스(이하 "베풂"이라고 함)를 이용을 함에 있어, 사용자는 아래의 이용 약관을 숙지를 하고 준수를 하여야 합니다.
          </div>
          <div class="setting-tit-box">[개인의 정보 처리에 대한 방침]</div>
          <div class="setting-des-box">
             본 베풂은 개인의 정보를 수집을 하지 않습니다.
          </div>

          <div class="setting-tit-box">[저작권 및 지적인 재산권에 대한 고지]</div>
          <div class="setting-des-box">
            1. 본 베풂은 비영리로 운영이 되며, 베풂에 게시가 된 모든 내용의 저작권은 본 베풂의 제공자에게 있습니다.<br />
            2. 이용자는 베풂을 통해 제공이 되는 내용을 비영리의 목적으로만 사용을 할 수 있으며, 상업적 또는 영리적인 목적으로는 이용을 할 수 없습니다.
          </div>

          <div class="setting-tit-box">[책임의 제한 및 면책의 조항]</div>
          <div class="setting-des-box">
            본 베풂의 제공자는 본 베풂의 이용 중에 발생을 하는 어떠한 손해에 대해서도 책임을 지지 않습니다.
          </div>

          <div class="setting-tit-box">[베풂의 변경 및 중단]</div>
          <div class="setting-des-box">
            본 베풂의 제공자는 베푸는 내용을 사전에 통지를 하지 않고 변경을 하거나 베풂을 중단을 할 수 있습니다.
          </div>

          <div class="setting-tit-box">[이용 약관의 변경]</div>
          <div class="setting-des-box">
            본 베풂의 제공자는 이용 약관을 개정을 할 권리가 있으며, 변경이 되는 사항은 본 베풂 안에서 사전에 공지를 할 것입니다.<br />
            본 베풂은 개인의 정보를 가지지 않기 때문에 모든 사용자는 일체의 의무가 없습니다. 즉, 변경이 된 약관에 동의를 하지 않는 사용자는 본 베풂의 이용을 중단을 하면 됩니다.
          </div>

          <div class="setting-tit-box">[관할 법원 및 준거법]</div>
          <div class="setting-des-box">
            본 이용 약관에 관한 분쟁에 대해서는 대한민국 법률이 적용이 되며, 관할 법원은 본 베풂의 제공자의 소재지의 법원으로 합니다.
          </div>

          <div class="setting-des-box">
            본 고지문은 2025년 2월 12일부터 적용이 됨을 알려 드립니다.
          </div>
        </div>

      </div>

    </div>

  </section>

</div>
